import dayjs from 'dayjs';

export class DateUtils {
  public static getFormattedDate(date: string): string {
    return dayjs(date).format('DD.MM.YYYY');
  }
}
